import * as types from './mutation-types';

export default {
  [types.SET_APIKEY](state, apikey) {
    if (apikey) {
      state.isLogged = true;
    } else {
      state.isLogged = false;
    }

    state.apikey = apikey;
    localStorage.setItem('userInfo', JSON.stringify(state));
  },

  [types.LOG_OUT](state) {
    localStorage.removeItem('userInfo');

    state.account = {};
    state.apikey = '';
    state.isLogged = false;
  },

  [types.SET_USER_INFO](state, serverInfo) {
    state.account = serverInfo;
    localStorage.setItem('userInfo', JSON.stringify(state));
  },

  [types.SET_USER_JWT](state, JWT) {
    state.jwt = JWT;
    localStorage.setItem('userInfo', JSON.stringify(state));
  },

  [types.SET_RESET_INFO](state, resetInfo) {
    state.resetInfo = resetInfo;
  },

  [types.SET_REGISTER_INFO](state, registerInfo) {
    state.registerInfo = registerInfo;
  },

  [types.SET_LANGUAGE](state, language) {
    state.language = language;
    localStorage.setItem('userInfo', JSON.stringify(state));
  },

  [types.SET_COOKIES](state) {
    state.acceptedCookies = new Date();
    localStorage.setItem('acceptedCookies', state.acceptedCookies.toISOString());
  },

  [types.SET_SECRET_QUESTIONS](state, secretQuestions) {
    state.secretQuestions = secretQuestions;
  },
};
